"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubUseCaseDetails = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var react_router_dom_1 = require("react-router-dom");
var FileSaver = __importStar(require("file-saver"));
var react_markdown_preview_1 = __importDefault(require("@uiw/react-markdown-preview"));
require("@uiw/react-markdown-preview/markdown.css");
var config_1 = require("../config");
var ai_hub_use_case_output_api_service_1 = __importDefault(require("../shared/services/ai-hub-use-case-output-api.service"));
var AiHubLoadingState_1 = require("../shared/AiHubLoadingState");
var UseCaseAlignment_1 = require("../UseCaseAlignment/UseCaseAlignment");
require("./styles/use-case-details.scss");
var use_case_details_utils_1 = require("./utils/use-case-details-utils");
var use_case_details_constants_1 = require("./utils/use-case-details-constants");
var markdown_highlight_components_1 = require("./utils/markdown-highlight-components");
var use_case_highlights_service_1 = require("./services/use-case-highlights.service");
var extraction_run_service_1 = require("./services/extraction-run.service");
var manual_elements_service_1 = require("./services/manual-elements.service");
var SelectionPopup_1 = require("./components/SelectionPopup/SelectionPopup");
/**
 * Rich use case details page with report tabs and multi-pane reading controls.
 */
var WsAiHubUseCaseDetails = function (props) {
    var _a, _b;
    var params = react_router_dom_1.useParams();
    var _c = react_1.useState(null), useCaseOutput = _c[0], setUseCaseOutput = _c[1];
    var _d = react_1.useState(true), isLoadingOutput = _d[0], setIsLoadingOutput = _d[1];
    var _e = react_1.useState(''), outputError = _e[0], setOutputError = _e[1];
    var _f = react_1.useState(window.innerWidth), viewportWidth = _f[0], setViewportWidth = _f[1];
    var _g = react_1.useState(window.innerHeight), viewportHeight = _g[0], setViewportHeight = _g[1];
    var _h = react_1.useState(1), selectedColumnCount = _h[0], setSelectedColumnCount = _h[1];
    var _j = react_1.useState(['info']), paneTabKeys = _j[0], setPaneTabKeys = _j[1];
    var _k = react_1.useState(5), fontScaleIndex = _k[0], setFontScaleIndex = _k[1];
    var _l = react_1.useState(use_case_details_constants_1.clampMultiColumnPaneHeight(window.innerHeight - use_case_details_constants_1.MULTI_COLUMN_PANE_VERTICAL_OFFSET)), multiColumnPaneHeight = _l[0], setMultiColumnPaneHeight = _l[1];
    var _m = react_1.useState(false), isResizingColumns = _m[0], setIsResizingColumns = _m[1];
    var _o = react_1.useState(false), isOptimising = _o[0], setIsOptimising = _o[1];
    var _p = react_1.useState(false), isAnalysing = _p[0], setIsAnalysing = _p[1];
    var _q = react_1.useState(false), isSyncingAnalysis = _q[0], setIsSyncingAnalysis = _q[1];
    var _r = react_1.useState(null), extractionRunStatus = _r[0], setExtractionRunStatus = _r[1];
    var _s = react_1.useState(null), actionMessage = _s[0], setActionMessage = _s[1];
    var _t = react_1.useState(null), activeHeadingId = _t[0], setActiveHeadingId = _t[1];
    var _u = react_1.useState(0), readingProgress = _u[0], setReadingProgress = _u[1];
    var _v = react_1.useState([]), highlightItems = _v[0], setHighlightItems = _v[1];
    var _w = react_1.useState(null), selectionAnchor = _w[0], setSelectionAnchor = _w[1];
    var _x = react_1.useState(false), isSavingSelection = _x[0], setIsSavingSelection = _x[1];
    var readerRootRef = react_1.useRef(null);
    var useCase = (_a = props.useCases) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === params.useCaseId; });
    // Fetch entity highlights for this use case so the markdown reader
    // can wrap real element references with `<HighlightedTerm>` (and
    // open the popup with real backend data on click). A failed or
    // empty response just leaves the markdown un-decorated.
    react_1.useEffect(function () {
        var cancelled = false;
        if (!params.useCaseId) {
            setHighlightItems([]);
            return undefined;
        }
        use_case_highlights_service_1.fetchUseCaseHighlights(params.useCaseId).then(function (items) {
            if (!cancelled) {
                setHighlightItems(items);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [params.useCaseId]);
    // Rebuilds the regex + alias index only when the items array
    // identity changes — cheap O(n) on highlights, n is typically
    // <100 per use case.
    var markdownComponents = react_1.useMemo(function () {
        return markdown_highlight_components_1.buildMarkdownHighlightComponents({
            items: highlightItems,
            useCaseId: params.useCaseId,
        });
    }, [highlightItems, params.useCaseId]);
    var tabs = react_1.useMemo(function () {
        return useCase ? use_case_details_utils_1.buildUseCaseDetailTabs(useCase, useCaseOutput) : [];
    }, [useCase, useCaseOutput]);
    var maxReaderColumns = use_case_details_utils_1.getMaxReaderColumns(viewportWidth);
    var visibleColumnCount = Math.min(selectedColumnCount, maxReaderColumns);
    var activeTabKey = paneTabKeys[0] || 'info';
    var targetSystemWorkItemId = ((_b = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.Draft) === null || _b === void 0 ? void 0 : _b.TargetSystemID) || null;
    var resizeStartRef = react_1.useRef(null);
    var sidebarInnerRef = react_1.useRef(null);
    var refreshOutput = react_1.useCallback(function (showLoader) {
        if (showLoader === void 0) { showLoader = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (showLoader) {
                            setIsLoadingOutput(true);
                        }
                        return [4 /*yield*/, ai_hub_use_case_output_api_service_1.default.getUseCaseOutput(params.useCaseId)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            setUseCaseOutput(result);
                            setOutputError('');
                        }
                        else {
                            setUseCaseOutput(null);
                            setOutputError('Detailed generated content is not available yet for this use case.');
                        }
                        if (showLoader) {
                            setIsLoadingOutput(false);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    }, [params.useCaseId]);
    react_1.useEffect(function () {
        var handleResize = function () {
            setViewportWidth(window.innerWidth);
            setViewportHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    react_1.useEffect(function () {
        setMultiColumnPaneHeight(function (currentHeight) {
            return use_case_details_constants_1.clampMultiColumnPaneHeight(currentHeight);
        });
    }, [viewportHeight]);
    react_1.useEffect(function () {
        if (!isResizingColumns) {
            return;
        }
        var handleMouseMove = function (event) {
            var resizeStart = resizeStartRef.current;
            if (!resizeStart) {
                return;
            }
            var deltaY = event.clientY - resizeStart.startY;
            setMultiColumnPaneHeight(use_case_details_constants_1.clampMultiColumnPaneHeight(resizeStart.startHeight + deltaY));
        };
        var stopResizing = function () {
            setIsResizingColumns(false);
            resizeStartRef.current = null;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.body.style.cursor = 'ns-resize';
        document.body.style.userSelect = 'none';
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', stopResizing);
        return function () {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', stopResizing);
        };
    }, [isResizingColumns, viewportHeight]);
    react_1.useEffect(function () {
        var isMounted = true;
        var loadOutput = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ai_hub_use_case_output_api_service_1.default.getUseCaseOutput(params.useCaseId)];
                    case 1:
                        result = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        if (result) {
                            setUseCaseOutput(result);
                            setOutputError('');
                        }
                        else {
                            setUseCaseOutput(null);
                            setOutputError('Detailed generated content is not available yet for this use case.');
                        }
                        setIsLoadingOutput(false);
                        return [2 /*return*/];
                }
            });
        }); };
        loadOutput();
        return function () {
            isMounted = false;
        };
    }, [params.useCaseId]);
    react_1.useEffect(function () {
        if (tabs.length === 0) {
            return;
        }
        var nextPaneKeys = use_case_details_utils_1.buildDefaultPaneTabKeys(tabs, visibleColumnCount);
        setPaneTabKeys(function (currentKeys) {
            var mergedKeys = nextPaneKeys.map(function (defaultKey, index) {
                var currentKey = currentKeys[index];
                var tabExists = tabs.some(function (tab) { return tab.key === currentKey; });
                return tabExists ? currentKey : defaultKey;
            });
            return mergedKeys;
        });
    }, [tabs, visibleColumnCount]);
    react_1.useEffect(function () {
        if (selectedColumnCount > maxReaderColumns) {
            setSelectedColumnCount(maxReaderColumns);
        }
    }, [maxReaderColumns, selectedColumnCount]);
    react_1.useEffect(function () {
        var nextDefaultScale = use_case_details_constants_1.DEFAULT_FONT_SCALE_BY_COLUMN_COUNT[visibleColumnCount] || 100;
        var nextFontScaleIndex = use_case_details_constants_1.FONT_SCALE_OPTIONS.findIndex(function (value) { return value === nextDefaultScale; });
        if (nextFontScaleIndex >= 0) {
            setFontScaleIndex(nextFontScaleIndex);
        }
    }, [visibleColumnCount]);
    react_1.useEffect(function () {
        if (visibleColumnCount !== 1) {
            setActiveHeadingId(null);
            setReadingProgress(0);
            return;
        }
        var activeTab = tabs.find(function (t) { return t.key === activeTabKey; });
        if (!activeTab || activeTab.headings.length === 0) {
            setActiveHeadingId(null);
            setReadingProgress(0);
            return;
        }
        var paneKey = 'pane-1';
        // Resolve section elements lazily — markdown can render async, so an
        // element missing on the first read may exist on subsequent frames.
        var resolveSections = function () {
            return activeTab.headings
                .map(function (h) { return ({
                id: h.id,
                el: document.getElementById(paneKey + "-" + h.id),
            }); })
                .filter(function (s) { return s.el !== null; });
        };
        // Local trackers to guard setState — prevents re-renders when value hasn't changed
        var currentActiveId = null;
        var currentProgress = -1;
        var rafHandle = null;
        var computeProgress = function () {
            // Use the document scroll metrics — the page is the scroll container,
            // and these values stay accurate regardless of when markdown finishes
            // laying out, so the initial reload value tracks the user's scrolling.
            var docEl = document.documentElement;
            var scrollTop = window.scrollY || docEl.scrollTop || 0;
            var total = docEl.scrollHeight - window.innerHeight;
            if (total <= 0) {
                return 0;
            }
            return Math.min(100, Math.max(0, Math.round((scrollTop / total) * 100)));
        };
        var handleScroll = function () {
            // RAF throttle — at most one execution per animation frame
            if (rafHandle !== null) {
                return;
            }
            rafHandle = requestAnimationFrame(function () {
                rafHandle = null;
                // Active heading: last section whose top has crossed 25% of the viewport
                var sections = resolveSections();
                var readingLine = window.innerHeight * 0.25;
                var newActiveId = null;
                for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
                    var _a = sections_1[_i], id = _a.id, el = _a.el;
                    if (el.getBoundingClientRect().top <= readingLine) {
                        newActiveId = id;
                    }
                }
                if (newActiveId !== currentActiveId) {
                    currentActiveId = newActiveId;
                    setActiveHeadingId(newActiveId);
                }
                var progress = computeProgress();
                if (progress !== currentProgress) {
                    currentProgress = progress;
                    setReadingProgress(progress);
                }
            });
        };
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll, { passive: true });
        // Observe the document body so we recompute progress whenever the page
        // height changes (async markdown layout, lazy images, fonts, etc.).
        var resizeObserver = null;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleScroll);
            resizeObserver.observe(document.body);
        }
        return function () {
            if (rafHandle !== null) {
                cancelAnimationFrame(rafHandle);
            }
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
            setActiveHeadingId(null);
            setReadingProgress(0);
        };
    }, [activeTabKey, visibleColumnCount, tabs]);
    react_1.useEffect(function () {
        var container = sidebarInnerRef.current;
        if (!container || !activeHeadingId) {
            return;
        }
        var activeLink = container.querySelector("[data-heading-id=\"" + activeHeadingId + "\"]");
        if (!activeLink) {
            return;
        }
        var scrollTarget = activeLink.offsetTop - container.clientHeight / 2 + activeLink.clientHeight / 2;
        container.scrollTo({ top: scrollTarget, behavior: 'smooth' });
    }, [activeHeadingId]);
    var updatePaneTab = function (paneIndex, tabKey) {
        setPaneTabKeys(function (currentKeys) {
            var nextKeys = __spreadArrays(currentKeys);
            nextKeys[paneIndex] = tabKey;
            return nextKeys;
        });
    };
    var getTabTitle = function (tab, tabIndex) {
        return tabIndex + 1 + ". " + tab.title;
    };
    var handleMultiColumnResizeStart = function (event) {
        event.preventDefault();
        resizeStartRef.current = {
            startY: event.clientY,
            startHeight: multiColumnPaneHeight,
        };
        setIsResizingColumns(true);
    };
    var buildVisibleExportText = function () {
        var visibleTabs = paneTabKeys
            .slice(0, visibleColumnCount)
            .map(function (tabKey) { return tabs.find(function (tab) { return tab.key === tabKey; }); })
            .filter(function (tab) { return !!tab; });
        return visibleTabs.map(function (tab) { return use_case_details_utils_1.buildTabExportText(tab); }).join('\n\n=====\n\n');
    };
    var exportVisibleText = function () {
        var file = new Blob([buildVisibleExportText()], {
            type: 'text/plain;charset=utf-8',
        });
        FileSaver.saveAs(file, params.useCaseId + "-use-case-report.txt");
    };
    var handleOpenWorkItem = react_1.useCallback(function () {
        if (!targetSystemWorkItemId) {
            return;
        }
        var workItemUrl = "https://dev.azure.com/" + encodeURIComponent(use_case_details_constants_1.AZURE_DEVOPS_ORGANISATION) + "/" + encodeURIComponent(use_case_details_constants_1.AZURE_DEVOPS_PROJECT) + "/_workitems/edit/" + encodeURIComponent(targetSystemWorkItemId);
        window.open(workItemUrl, '_blank', 'noopener,noreferrer');
    }, [targetSystemWorkItemId]);
    var handleOptimise = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsOptimising(true);
                    setActionMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, config_1.getApiPut()("/ai/ukdc/use-cases/" + encodeURIComponent(params.useCaseId) + "/optimise", {})];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refreshOutput(false)];
                case 3:
                    _a.sent();
                    setActionMessage({
                        text: 'Use case optimisation completed successfully.',
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    setActionMessage({
                        text: error_1 instanceof Error ? error_1.message : 'Failed to optimise use case.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsOptimising(false);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, refreshOutput]);
    var handleStartAnalysis = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsAnalysing(true);
                    setActionMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, config_1.getApiPut()("/ai/ukdc/use-cases/" + encodeURIComponent(params.useCaseId) + "/analyse", {})];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refreshOutput(false)];
                case 3:
                    _a.sent();
                    setActionMessage({
                        text: 'Use case analysis started successfully.',
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    setActionMessage({
                        text: error_2 instanceof Error ? error_2.message : 'Failed to start use case analysis.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsAnalysing(false);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, refreshOutput]);
    /**
     * Wait for an in-flight extraction run to reach a terminal status,
     * keep the "Syncing..." loader visible while it does, and refresh
     * the markdown highlights once it completes.
     *
     * Shared by:
     *  - {@link handleSyncAnalysis} — after the user clicks Sync.
     *  - The mount effect — when the page is loaded mid-extraction
     *    (user reloaded, navigated back, or another tab kicked it
     *    off), so the loader and disabled button are restored without
     *    requiring the user to keep the original tab open.
     */
    var trackExtractionRun = react_1.useCallback(function (runId, initialStatus, isCancelled) {
        if (initialStatus === void 0) { initialStatus = 'queued'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var finalRun, finalStatus, items;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsSyncingAnalysis(true);
                        setExtractionRunStatus(initialStatus);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 4, 5]);
                        return [4 /*yield*/, extraction_run_service_1.pollExtractionRun(runId, {
                                onUpdate: function (snapshot) { return setExtractionRunStatus(snapshot.status); },
                                isCancelled: isCancelled,
                            })];
                    case 2:
                        finalRun = _b.sent();
                        if (isCancelled === null || isCancelled === void 0 ? void 0 : isCancelled()) {
                            return [2 /*return*/];
                        }
                        finalStatus = (_a = finalRun === null || finalRun === void 0 ? void 0 : finalRun.status) !== null && _a !== void 0 ? _a : null;
                        return [4 /*yield*/, use_case_highlights_service_1.fetchUseCaseHighlights(params.useCaseId)];
                    case 3:
                        items = _b.sent();
                        if (isCancelled === null || isCancelled === void 0 ? void 0 : isCancelled()) {
                            return [2 /*return*/];
                        }
                        setHighlightItems(items);
                        if (finalStatus === 'success') {
                            setActionMessage({
                                text: "Analysis synchronised and " + items.length + " element reference" + (items.length === 1 ? '' : 's') + " extracted (run #" + runId + ").",
                                type: office_ui_fabric_react_1.MessageBarType.success,
                            });
                        }
                        else if (finalStatus) {
                            setActionMessage({
                                text: "Analysis synchronised, but element extraction finished with status \"" + finalStatus + "\" (run #" + runId + ").",
                                type: office_ui_fabric_react_1.MessageBarType.warning,
                            });
                        }
                        else {
                            setActionMessage({
                                text: "Analysis synchronised. Element extraction is still running (run #" + runId + "); refresh later.",
                                type: office_ui_fabric_react_1.MessageBarType.warning,
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (!(isCancelled === null || isCancelled === void 0 ? void 0 : isCancelled())) {
                            setIsSyncingAnalysis(false);
                            setExtractionRunStatus(null);
                            setTimeout(function () { return setActionMessage(null); }, 5000);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [params.useCaseId]);
    // Restore the "Syncing..." loader when the page loads while an
    // extraction run is still in flight (e.g. the user reloaded mid-
    // sync, opened the page in a second tab, or another teammate
    // triggered Sync Analysis on the same use case). The backend
    // exposes the active run via GET /extraction/use-cases/:id/active-run
    // and 204s when there is none, so a quiet `null` is the happy path.
    react_1.useEffect(function () {
        if (!params.useCaseId) {
            return undefined;
        }
        var cancelled = false;
        extraction_run_service_1.fetchActiveExtractionRun(params.useCaseId).then(function (active) {
            if (cancelled || !active) {
                return;
            }
            void trackExtractionRun(active.id, active.status, function () { return cancelled; });
        });
        return function () {
            cancelled = true;
        };
    }, [params.useCaseId, trackExtractionRun]);
    /**
     * Resolve the section heading nearest to a DOM node so the manual
     * mention can be persisted with a meaningful `section` (matches the
     * heading-id convention used by `renderMarkdownTabContent`). Falls
     * back to `'manual-selection'` when no section ancestor is found.
     */
    var resolveSectionForNode = react_1.useCallback(function (node) {
        var current = node;
        while (current && current.nodeType !== Node.ELEMENT_NODE) {
            current = current.parentNode;
        }
        while (current instanceof HTMLElement) {
            var id = current.id;
            if (id && id.startsWith('pane-')) {
                // id shape: `pane-{n}-{sectionId}` → strip pane prefix to
                // recover the original section id.
                var stripped = id.replace(/^pane-\d+-/, '');
                if (stripped && stripped !== id) {
                    return stripped;
                }
            }
            current = current.parentElement;
        }
        return 'manual-selection';
    }, []);
    /**
     * Listen for text selections inside the markdown reader. Shows the
     * SelectionPopup anchored at the selection rectangle. Selections
     * outside the reader (e.g. headers, sidebar) are ignored.
     */
    react_1.useEffect(function () {
        var handleMouseUp = function () {
            // Defer one tick — `getSelection()` can lag on click-drag-release.
            window.setTimeout(function () {
                var selection = window.getSelection();
                if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
                    return;
                }
                var text = selection.toString().trim();
                if (text.length === 0 || text.length > 2000) {
                    return;
                }
                var range = selection.getRangeAt(0);
                var root = readerRootRef.current;
                if (!root || !root.contains(range.commonAncestorContainer)) {
                    return;
                }
                var rect = range.getBoundingClientRect();
                if (rect.width === 0 && rect.height === 0) {
                    return;
                }
                var section = resolveSectionForNode(range.startContainer);
                setSelectionAnchor({
                    x: rect.left + rect.width / 2 - 160,
                    y: rect.bottom + 8,
                    text: text,
                    section: section,
                });
            }, 0);
        };
        document.addEventListener('mouseup', handleMouseUp);
        return function () {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [resolveSectionForNode]);
    var handleSelectionDismiss = react_1.useCallback(function () {
        setSelectionAnchor(null);
    }, []);
    var handleSelectionSubmit = react_1.useCallback(function (input) { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, verb, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectionAnchor) {
                        return [2 /*return*/];
                    }
                    setIsSavingSelection(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, manual_elements_service_1.addManualElement(params.useCaseId, {
                            elementType: input.elementType,
                            canonicalName: input.canonicalName,
                            description: input.description,
                            section: selectionAnchor.section,
                            excerpt: selectionAnchor.text,
                        })];
                case 2:
                    response_1 = _b.sent();
                    // Optimistically append so the new highlight is visible
                    // immediately without a round-trip refetch.
                    setHighlightItems(function (current) { return __spreadArrays(current, [response_1.item]); });
                    setSelectionAnchor(null);
                    verb = response_1.created ? 'created' : 'linked to existing element';
                    setActionMessage({
                        text: "Element \"" + response_1.item.canonicalName + "\" " + verb + ".",
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    setTimeout(function () { return setActionMessage(null); }, 4000);
                    // Clear the browser selection so the highlight is visible.
                    (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _b.sent();
                    setActionMessage({
                        text: error_3 instanceof Error
                            ? "Failed to add element: " + error_3.message
                            : 'Failed to add element.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSavingSelection(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, selectionAnchor]);
    var handleSyncAnalysis = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, extraction, runId, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsSyncingAnalysis(true);
                    setExtractionRunStatus('queued');
                    setActionMessage(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, config_1.getApiPut()("/ai/ukdc/use-cases/" + encodeURIComponent(params.useCaseId) + "/sync-analysis", {})];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, refreshOutput(false)];
                case 3:
                    _b.sent();
                    extraction = (_a = response) === null || _a === void 0 ? void 0 : _a.extraction;
                    runId = extraction === null || extraction === void 0 ? void 0 : extraction.runId;
                    if (!runId) return [3 /*break*/, 5];
                    // Defer to the shared tracker; it owns the loader/banner/
                    // highlight refresh state machine.
                    return [4 /*yield*/, trackExtractionRun(runId, 'queued')];
                case 4:
                    // Defer to the shared tracker; it owns the loader/banner/
                    // highlight refresh state machine.
                    _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setActionMessage({
                        text: 'Analysis synchronisation completed successfully.',
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    setIsSyncingAnalysis(false);
                    setExtractionRunStatus(null);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    _b.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_4 = _b.sent();
                    setActionMessage({
                        text: error_4 instanceof Error ? error_4.message : 'Failed to sync analysis.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    setIsSyncingAnalysis(false);
                    setExtractionRunStatus(null);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, refreshOutput, trackExtractionRun]);
    var renderSecondaryAction = function (key, text, iconName, disabled, onClick, stepNumber) {
        return (react_1.default.createElement("div", { key: key, className: "ws-ai-hub-use-case-details-secondary-action-item" },
            react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ws-ai-hub-use-case-details-secondary-action-button ws-admin-button-hover-accent", iconProps: iconName ? { iconName: iconName } : undefined, disabled: disabled, onClick: onClick },
                stepNumber ? (react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-secondary-action-step" }, stepNumber)) : null,
                react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-secondary-action-button-text" }, text))));
    };
    var renderMarkdownTabContent = function (tab, paneKey) {
        return tab.sections.map(function (section) { return (react_1.default.createElement("div", { key: paneKey + "-" + section.id, id: paneKey + "-" + section.id, className: "ws-ai-hub-use-case-details-markdown-section" },
            react_1.default.createElement(react_markdown_preview_1.default, { source: section.markdown, className: "ws-ai-hub-use-case-details-markdown", components: markdownComponents, rehypePlugins: [use_case_details_utils_1.rehypeSanitizeMarkdown] }))); });
    };
    var renderAllTabSectionHeader = function (title, tabIndex) {
        return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-all-header" },
            react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-all-kicker" }, "Tab Content"),
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-all-title" }, tabIndex + 1 + ". " + title)));
    };
    var renderTabContent = function (tab, paneKey) {
        if (tab.kind === 'alignment') {
            return (react_1.default.createElement("div", { id: paneKey + "-alignment-graph" },
                react_1.default.createElement(UseCaseAlignment_1.WsUseCaseAlignment, { useCaseId: params.useCaseId })));
        }
        if (tab.kind === 'all') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                tabs
                    .filter(function (item) { return item.kind === 'markdown'; })
                    .map(function (item, tabIndex) { return (react_1.default.createElement("div", { key: paneKey + "-" + item.key },
                    renderAllTabSectionHeader(item.title, tabIndex),
                    renderMarkdownTabContent(item, paneKey),
                    react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-all-divider" }))); }),
                react_1.default.createElement("div", { id: paneKey + "-alignment-graph", className: "ws-ai-hub-use-case-details-markdown-section" },
                    renderAllTabSectionHeader('Use Case Alignment', tabs.filter(function (item) { return item.kind === 'markdown'; }).length),
                    react_1.default.createElement(UseCaseAlignment_1.WsUseCaseAlignment, { useCaseId: params.useCaseId }))));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, renderMarkdownTabContent(tab, paneKey));
    };
    var renderSidebar = function (tab, paneKey) {
        return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar" },
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-inner", ref: sidebarInnerRef },
                react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-sidebar-title" }, "Contents"),
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-list" }, tab.headings.map(function (heading) { return (react_1.default.createElement("a", { key: paneKey + "-" + heading.id, className: [
                        'ws-ai-hub-use-case-details-sidebar-link',
                        "ws-ai-hub-use-case-details-sidebar-link-level-" + heading.level,
                        heading.id === activeHeadingId
                            ? 'ws-ai-hub-use-case-details-sidebar-link--active'
                            : '',
                    ]
                        .filter(Boolean)
                        .join(' '), "data-heading-id": heading.id, href: "#" + paneKey + "-" + heading.id }, heading.text)); }))),
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress" },
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress-header" },
                    react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-sidebar-progress-label" }, "Reading Progress"),
                    react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-sidebar-progress-value" },
                        readingProgress,
                        "%")),
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress-bar" },
                    react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress-bar-fill", style: { width: readingProgress + "%" } })))));
    };
    var renderPane = function (tabKey, paneIndex) {
        var tab = tabs.find(function (item) { return item.key === tabKey; });
        if (!tab) {
            return null;
        }
        var paneKey = "pane-" + (paneIndex + 1);
        var shouldRenderSidebar = visibleColumnCount === 1 && tab.kind !== 'alignment' && tab.headings.length > 0;
        return (react_1.default.createElement("div", { key: paneKey, className: "ws-ai-hub-use-case-details-pane ws-ai-hub-use-case-details-scale-" + use_case_details_constants_1.FONT_SCALE_OPTIONS[fontScaleIndex], style: visibleColumnCount > 1 ? { height: multiColumnPaneHeight + "px" } : undefined },
            visibleColumnCount === 1 ? (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-tabs" },
                react_1.default.createElement("div", { className: "tabs is-boxed" },
                    react_1.default.createElement("ul", null, tabs.map(function (item, tabIndex) { return (react_1.default.createElement("li", { key: item.key, className: [
                            activeTabKey === item.key ? 'is-active' : '',
                            item.key === 'all' ? 'ws-ai-hub-use-case-details-tab-with-separator' : '',
                        ]
                            .filter(Boolean)
                            .join(' ') },
                        react_1.default.createElement("a", { href: "#tab", onClick: function (event) {
                                event.preventDefault();
                                updatePaneTab(0, item.key);
                            } }, getTabTitle(item, tabIndex)))); }))))) : (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-selector" },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Pane " + (paneIndex + 1), selectedKey: tab.key, options: tabs.map(function (item, tabIndex) { return ({
                        key: item.key,
                        text: getTabTitle(item, tabIndex),
                    }); }), onChange: function (event, option) {
                        updatePaneTab(paneIndex, "" + ((option === null || option === void 0 ? void 0 : option.key) || tab.key));
                    } }))),
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-body " + (!shouldRenderSidebar ? 'ws-ai-hub-use-case-details-pane-body-no-sidebar' : '') },
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-content" }, renderTabContent(tab, paneKey)),
                shouldRenderSidebar && renderSidebar(tab, paneKey))));
    };
    if (!useCase) {
        return react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-empty" }, "Use case not found.");
    }
    var syncingAnalysisLabel = (function () {
        switch (extractionRunStatus) {
            case 'queued':
                return 'Syncing analysis. Element extraction queued, please wait...';
            case 'running':
                return 'Syncing analysis. Extracting elements from the use case, this can take up to 1 minute...';
            case 'success':
                return 'Element extraction finished. Loading highlights...';
            case 'schema-failed':
            case 'agent-error':
            case 'timeout':
                return "Element extraction finished with status \"" + extractionRunStatus + "\". Cleaning up...";
            default:
                return 'Syncing analysis. Please wait, this can take up to 1 minute...';
        }
    })();
    var loadingLabel = isOptimising
        ? 'Optimizing use case. Please wait, this can take up to 1 minute...'
        : isAnalysing
            ? 'Starting analysis. Please wait, this can take up to 1 minute...'
            : isSyncingAnalysis
                ? syncingAnalysisLabel
                : use_case_details_constants_1.DEFAULT_OUTPUT_LOADING_LABEL;
    if (isLoadingOutput || isOptimising || isAnalysing || isSyncingAnalysis) {
        return (react_1.default.createElement(AiHubLoadingState_1.AiHubLoadingState, { label: loadingLabel, className: "ws-ai-hub-use-case-details-loading-screen", isFullScreen: true }));
    }
    return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details" },
        react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-header-card" },
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-header" },
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-secondary-actions" },
                    renderSecondaryAction('open-work-item', 'Open Work Item', 'OpenInNewWindow', !targetSystemWorkItemId, handleOpenWorkItem),
                    react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-secondary-action-separator" }),
                    renderSecondaryAction('optimise', isOptimising ? 'Optimising...' : 'Optimise', undefined, isOptimising || isAnalysing || isSyncingAnalysis, handleOptimise, 1),
                    renderSecondaryAction('start-analysis', isAnalysing ? 'Analysing...' : 'Start Analysis', undefined, isOptimising || isAnalysing || isSyncingAnalysis, handleStartAnalysis, 2),
                    renderSecondaryAction('sync-analysis', isSyncingAnalysis ? 'Syncing...' : 'Sync Analysis', undefined, isOptimising || isAnalysing || isSyncingAnalysis, handleSyncAnalysis, 3),
                    react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: use_case_details_constants_1.UCA_ACTIONS_TOOLTIP_TEXT },
                        react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "UnknownSolid", className: "ws-ai-hub-use-case-details-secondary-action-help" }))),
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-controls-panel" },
                    react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-controls" },
                        react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-control-group" },
                            react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-control-label" }, "Split view"),
                            react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { selectedKey: selectedColumnCount, options: [1, 2, 3].map(function (count) { return ({
                                    key: count,
                                    text: count + " column" + (count > 1 ? 's' : ''),
                                    disabled: count > maxReaderColumns,
                                }); }), onChange: function (event, option) {
                                    if (option && !option.disabled) {
                                        setSelectedColumnCount(Number(option.key));
                                    }
                                } })),
                        react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-control-separator" }),
                        react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-control-group" },
                            react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-control-label" }, "Font size"),
                            react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { selectedKey: use_case_details_constants_1.FONT_SCALE_OPTIONS[fontScaleIndex], options: use_case_details_constants_1.FONT_SCALE_OPTIONS.map(function (value) { return ({
                                    key: value,
                                    text: value + "%",
                                }); }), onChange: function (event, option) {
                                    var nextIndex = use_case_details_constants_1.FONT_SCALE_OPTIONS.findIndex(function (value) { return value === (option === null || option === void 0 ? void 0 : option.key); });
                                    if (nextIndex >= 0) {
                                        setFontScaleIndex(nextIndex);
                                    }
                                } })),
                        react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-control-separator" }),
                        react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Action", menuProps: {
                                items: [
                                    {
                                        key: 'print',
                                        text: 'Print current view',
                                        iconProps: { iconName: 'Print' },
                                        onClick: function () { return window.print(); },
                                    },
                                    {
                                        key: 'export-text',
                                        text: 'Export visible text',
                                        iconProps: { iconName: 'Download' },
                                        onClick: exportVisibleText,
                                    },
                                ],
                            } }))))),
        actionMessage && (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-message" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: actionMessage.type }, actionMessage.text))),
        outputError && (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-message" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.info }, outputError))),
        tabs.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: readerRootRef, className: "ws-ai-hub-use-case-details-content ws-ai-hub-use-case-details-content-" + visibleColumnCount + " " + (isResizingColumns ? 'ws-ai-hub-use-case-details-content-is-resizing' : '') }, paneTabKeys
                .slice(0, visibleColumnCount)
                .map(function (tabKey, paneIndex) { return renderPane(tabKey, paneIndex); })),
            visibleColumnCount > 1 && (react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: "Drag to resize the split view height" },
                react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-use-case-details-resize-handle", onMouseDown: handleMultiColumnResizeStart, "aria-label": "Resize split view height" },
                    react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-resize-handle-line" })))))),
        selectionAnchor && (react_1.default.createElement(SelectionPopup_1.WsSelectionPopup, { anchor: selectionAnchor, isSubmitting: isSavingSelection, onSubmit: handleSelectionSubmit, onDismiss: handleSelectionDismiss }))));
};
exports.WsAiHubUseCaseDetails = WsAiHubUseCaseDetails;
